export function TitleAtom({title, className, style,children}){
    return(
        <div className="horizontal" style={{  ...style }}>
            <h5 className={`${className ? className : "screen-title"}`} style={{ flexGrow: 1, width: "auto",}}>{title}</h5>
            {children}
        </div>
    )
}